export default __webpack_public_path__ + "images/Three_Vessel_View_Trachea_dark.0b14321e2e8c79b2cf1ec4f91ae0e054.png";